import React, { useState, useEffect } from "react";
import SearchFilters from "./SearchFilters";
import equal from "deep-equal";

const filterElements = {
  search: SearchFilters,
};

function Filter(props) {
  const FilterElement = filterElements[props.filterType];
  const defaultFilters = props.defaultFilters ? props.defaultFilters : {};
  const [filters, setFilters] = useState(defaultFilters);

  useEffect(
    () => {
      props.onChange && props.onChange(filters);
    },
    [filters]
  );

  const resetToDefault = () => {
    setFilters(defaultFilters);
  };

  const onFilterChange = (event) => {
    setFilters({
      ...filters,
      [event.target.name]: event.target.value,
    });
  };

  const onTaxonomyChange = (e) => {
    if (
      e.filter((ele) => ele.type === "taxonomy" && ele.parentList.length === 0)
        .length === 0
    ) {
      // the root node is not present so a filter is set...
      setFilters({
        ...filters,
        taxonomy: e,
      });
    } else {
      // the root node is present so remove any filter as this is treated as all knowledge selected
      let newFilter = { ...filters };
      delete newFilter.taxonomy;
      setFilters({
        ...newFilter,
      });
    }
  };

  const handleSelectChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (name) => (e) => {
    if (e) {
      setFilters({ ...filters, [name]: new Date(e.valueOf()) });
    } else {
      let newFilter = { ...filters };
      delete newFilter[name];
      setFilters({ ...newFilter });
    }
  };

  const addChip = (key, chip) => {
    setFilters({
      ...filters,
      [key]: filters[key] ? [...filters[key], chip] : [chip],
    });
  };

  const deleteChip = (key, chip) => {
    let filtered = filters[key].filter((i) => i !== chip);
    setFilters({
      ...filters,
      [key]: [...filtered],
    });
  };

  const isFilterSet = (name) => {
    if (filters.hasOwnProperty(name)) {
      if (defaultFilters.hasOwnProperty(name)) {
        return !equal(filters[name], defaultFilters[name]);
      } else {
        return true;
      }
    }
    return false;
  };

  return (
    <FilterElement
      resetToDefault={resetToDefault}
      filters={filters}
      onChange={onFilterChange}
      filtersChanged={!equal(filters, defaultFilters)}
      isFilterSet={isFilterSet}
      onTaxonomyChange={onTaxonomyChange}
      handleDateChange={handleDateChange}
      handleSelectChange={handleSelectChange}
      addChip={addChip}
      deleteChip={deleteChip}
    />
  );
}

export default Filter;
